import { Component, ElementRef, HostListener } from '@angular/core';
import { I18nService, SUPPORTED_LANGUAGES } from 'src/app/core/services/i18n.service';

@Component({
  standalone: false,
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  supportedLanguages = SUPPORTED_LANGUAGES;
  isOpen = false;

  constructor(public i18n: I18nService, private elRef: ElementRef) {}

  get currentLangLabel(): string {
    return this.supportedLanguages.find(l => l.code === this.i18n.currentLang)?.label ?? '';
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  selectLanguage(code: string): void {
    this.i18n.setLanguage(code);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
